import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Skeleton from "@mui/material/Skeleton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import TurnedInNotOutlinedIcon from "@mui/icons-material/TurnedInNotOutlined";

import { getInteractionByType } from "../User/Create/interactions";

function Tab({ id, title, interactionType, isLoading, setOpenDialog }) {
  const history = useHistory();
  const { t } = useTranslation();
  const [openOptionMenu, setOpenOptionMenu] = React.useState(false);
  const openMenu = Boolean(openOptionMenu);

  const interaction = getInteractionByType(interactionType);
  const options = [
    {
      id: "schedule",
      title: t("common.buttons.schedule"),
      icon: <DateRangeOutlinedIcon />,
      visible: interactionType === 0, // You can only schedule surveys
    },
    /*   { id: "rename", title: "Rename", icon: <TitleIcon /> },
     { id: "duplicate", title: "Duplicate", icon: <FileCopyOutlinedIcon /> }, */
    {
      id: "export",
      title: t("surveys.export"),
      icon: <TurnedInNotOutlinedIcon />,
      visible: true,
    },
    {
      id: "remove",
      title: t("common.buttons.remove"),
      icon: <DeleteOutlineOutlinedIcon />,
      visible: true,
    },
  ];

  const handleOptionMenu = (event) => {
    setOpenOptionMenu(event.currentTarget);
  };

  const handleOptionMenuClose = () => {
    setOpenOptionMenu(false);
  };
  const handlOptionMenuItemClick = (optionId) => {
    switch (optionId) {
      case "remove":
        setOpenDialog({ open: true, type: "remove", id: id });
        break;
      case "schedule":
        history.push(`/scheduler/${id}`);
        break;
      case "export":
        setOpenDialog({ open: true, type: "export", id: id });
        break;

      default:
        break;
    }
    handleOptionMenuClose();
  };
  const renderLoadingTitle = (
    <Skeleton animation="wave" height={12} width={"75%"} />
  );

  const handleOnClick = useCallback(
    () =>
      history.push({
        pathname: "/editor",
        state: {
          interactionId: id,
          interaction: null,
        },
      }),
    [history, id]
  );

  return (
    <div>
      <Paper style={{ width: "100%" }}>
        <List sx={{ padding: 0 }}>
          <ListItem
            role={undefined}
            button
            onClick={handleOnClick}
            sx={{
              paddingTop: 2,
              paddingBottom: 2,
              borderRadius: 1,
            }}
          >
            <ListItemIcon>
              <Avatar
                aria-label="surveyAvatar"
                sx={{
                  backgroundColor: `items.${[interaction.id]}`,
                  textAlign: "center",
                  width: "32px",
                  height: "32px",
                  borderRadius: "30%",
                }}
              >
                <interaction.icon />
              </Avatar>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography noWrap variant="subtitle2">
                  {isLoading ? renderLoadingTitle : title}
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              <IconButton
                aria-label="more options"
                onClick={handleOptionMenu}
                sx={{ padding: 1 }}
                size="large"
              >
                <MoreVertIcon fontSize="small" />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </Paper>
      {openOptionMenu ? (
        <Menu
          id="menu-tab-options"
          anchorEl={openOptionMenu}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          disableScrollLock={true}
          open={openMenu}
          onClose={handleOptionMenuClose}
        >
          {options.map((option) =>
            option.visible ? (
              <MenuItem
                key={option.id}
                onClick={() => handlOptionMenuItemClick(option.id)}
              >
                <List dense={true} style={{ margin: "0", padding: "0" }}>
                  <ListItem style={{ margin: "0", padding: "0" }}>
                    <ListItemIcon>{option.icon}</ListItemIcon>
                    <ListItemText primary={option.title} />
                  </ListItem>
                </List>
              </MenuItem>
            ) : null
          )}
        </Menu>
      ) : null}
    </div>
  );
}

export default Tab;
